import { useEffect, useState } from 'react';
import { GetQuotationRequestResponseModel } from '../services/quote.interfaces';
import { getQuotation } from '../services/quote.service';

const transformQuote = (
  quote: GetQuotationRequestResponseModel
): GetQuotationRequestResponseModel => {
  return {
    ...quote,
    customerDetails: {
      ...quote.customerDetails,
      title: quote?.customerDetails?.title || '',
    },
  };
};

export const useGetQuote = (quoteRef: string, trackingRef: string) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [quote, setQuote] = useState<GetQuotationRequestResponseModel | null>(
    null
  );

  const [errors, setErrors] = useState<any>();

  useEffect(() => {
    async function fetchQuote() {
      try {
        const response = await getQuotation(quoteRef, trackingRef);
        if (response.data) {
          setIsLoading(false);
          setQuote(transformQuote(response.data));
        }
      } catch (error) {
        setIsLoading(false);
        setErrors(error);
      }
    }

    if (quoteRef) {
      fetchQuote();
    }
  }, [quoteRef, trackingRef]);

  return [quote, errors, isLoading];
};
